import React, { useEffect, useState } from 'react';
import { 
  Box,
  Paper,
  Typography,
  Button,
  CircularProgress,
  LinearProgress
} from '@mui/material';
import { East } from '@mui/icons-material';
import logo from "./logo.png";
export default function LogMonitor() {
  const [countdown, setCountdown] = useState(10);
  const [redirecting, setRedirecting] = useState(false);
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setRedirecting(true);
          window.location.href = "https://cloudlens.visteoncloud.com";
          return 0;
        }
        return prev - 1;
      });
      setProgress((prev) => prev - 10);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleRedirect = () => {
    setRedirecting(true);
    window.location.href = "https://cloudlens.visteoncloud.com";
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        backgroundColor: "#FFFFFF",
        overflow: "hidden",
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(to top, #00ADB5 5%, #FFFFFF 5%)",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 2,
          maxWidth: 400,
          width: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          mx: 2,
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Progress bar at the top */}
        <LinearProgress 
          variant="determinate" 
          value={progress} 
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            backgroundColor: '#E0E0E0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#00ADB5'
            }
          }}
        />

        <Box display="flex" justifyContent="center" mb={3}>
          {/* <img 
            src="https://powergrid.visteoncloud.com/static/media/logo.f564190e5a46e0b3ad33.png" 
            alt="Logo" 
            style={{ width: "120px", height: "auto" }} 
          /> */}
          <img src={logo} alt="Logo" className="w-24 h-auto" />
        </Box>

        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ color: "#222831", fontFamily: "Poppins" }}
        >
          We've Moved!
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
            mb: 3
          }}
        >
          <Typography
            variant="body1"
            sx={{ 
              color: "#393E46", 
              fontFamily: "Poppins",
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            Redirecting in 
            <Box
              sx={{
                backgroundColor: '#00ADB5',
                color: 'white',
                borderRadius: '50%',
                width: 32,
                height: 32,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                animation: 'pulse 1s infinite'
              }}
            >
              {countdown}
            </Box>
            seconds
          </Typography>
        </Box>

        {redirecting && (
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <CircularProgress sx={{ color: "#00ADB5" }} />
          </Box>
        )}

        <Box 
          sx={{ 
            mb: 3,
            p: 3,
            borderRadius: 2,
            backgroundColor: 'rgba(0, 173, 181, 0.05)',
            border: '1px solid rgba(0, 173, 181, 0.1)'
          }}
        >
          <Typography
            variant="body1"
            align="center"
            sx={{ 
              color: "#393E46", 
              fontFamily: "Poppins",
              mb: 2,
              fontWeight: 500
            }}
          >
            Important Information:
          </Typography>
          
          <Typography
            variant="body2"
            align="center"
            sx={{ 
              color: "#393E46", 
              fontFamily: "Poppins",
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }}
          >
            <Box 
              sx={{ 
                width: 6, 
                height: 6, 
                borderRadius: '50%', 
                backgroundColor: '#00ADB5' 
              }} 
            />
            Your data has been successfully migrated
          </Typography>
          
          <Typography
            variant="body2"
            align="center"
            sx={{ 
              color: "#FF0000", 
              fontFamily: "Poppins",
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }}
          >
            <Box 
              sx={{ 
                width: 6, 
                height: 6, 
                borderRadius: '50%', 
                backgroundColor: '#00ADB5' 
              }} 
            />
            Please reset your password on first login.
          </Typography>
          
          <Typography
            variant="body2"
            align="center"
            sx={{ 
              color: "#FF0000", 
              fontFamily: "Poppins",
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }}
          >
            <Box 
              sx={{ 
                width: 6, 
                height: 6, 
                borderRadius: '50%', 
                backgroundColor: '#00ADB5' 
              }} 
            />
             Your Existing Powergrid password will not work.
          </Typography>
          
          <Typography
            variant="body2"
            align="center"
            sx={{ 
              color: "#393E46", 
              fontFamily: "Poppins",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }}
          >
            <Box 
              sx={{ 
                width: 6, 
                height: 6, 
                borderRadius: '50%', 
                backgroundColor: '#00ADB5' 
              }} 
            />
            All your settings remain unchanged
          </Typography>
        </Box>

        <Box 
          sx={{ 
            bgcolor: "#F5F5F5",
            p: 2,
            borderRadius: 1,
            mb: 3,
            textAlign: "center",
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: '#E8E8E8',
              transform: 'scale(1.02)'
            }
          }}
        >
          <Typography
            variant="body1"
            sx={{ 
              color: "#222831", 
              fontFamily: "Poppins",
              fontWeight: 500
            }}
          >
            cloudlens.visteoncloud.com
          </Typography>
        </Box>

        <Button
          onClick={handleRedirect}
          variant="contained"
          fullWidth
          disabled={redirecting}
          endIcon={<East />}
          sx={{
            backgroundColor: "#00ADB5",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#007C7F",
              transform: 'translateY(-2px)'
            },
            fontFamily: "Poppins",
            textTransform: "none",
            py: 1.5,
            transition: 'all 0.3s ease'
          }}
        >
          Go to New Site Now
        </Button>
      </Paper>

      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
      </style>
    </Box>
  );
}